import { useState } from "react";
import { useDispatch } from "react-redux";
import CommonModal from "../modalLayout/CommonModal";
import FileUploadBox from "../fileUpload/FileUploadBox";
import { updateOrdersFilterSearch } from "../../../app/orderApi/filterSlice";
import { showToast } from "../../../helpers/Utils";
import Loader from "../loader/Loader";

const UploadOrderSheetModal = ({ show, setShow, setfile }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleConfirm = async () => {
    if (!uploadedFile) {
      showToast("Please upload a file before confirming.", "error");
      return;
    }

    setIsLoading(true);
    dispatch(updateOrdersFilterSearch({ orderSheet: uploadedFile }));
    setfile(uploadedFile);
    setTimeout(() => {
      setShow(false);
      setIsLoading(false);
    }, 500);
  };

  const handleCancel = () => {
    setfile(null);
    setShow(false);
  };

  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      title="Upload order number sheet"
      centered
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      confirmLoading={isLoading}
      cancelDisabled={isLoading}
    >
      {isLoading && <Loader />}
      <FileUploadBox setUploadedFile={setUploadedFile} type="xls" order />
    </CommonModal>
  );
};

export default UploadOrderSheetModal;
